import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://gfwfoznlkscxlgxisibl.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdmd2Zvem5sa3NjeGxneGlzaWJsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA1NTk3NDAsImV4cCI6MjA2NjEzNTc0MH0.npC7j8vNdsp4APTSNfxpi4BVIJ6qeSxC1no6gHxrwYU';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export class SupabaseRealtimeService {
  private subscriptions: any[] = [];

  subscribeToConversations(callback: (payload: any) => void) {
    const subscription = supabase
      .channel('conversations')
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'conversations' }, 
        callback
      )
      .subscribe();
    
    this.subscriptions.push(subscription);
    return subscription;
  }

  subscribeToMessages(conversationId: string, callback: (payload: any) => void) {
    const subscription = supabase
      .channel(`messages-${conversationId}`)
      .on('postgres_changes', 
        { 
          event: '*', 
          schema: 'public', 
          table: 'messages',
          filter: `conversation_id=eq.${conversationId}`
        }, 
        callback
      )
      .subscribe();
    
    this.subscriptions.push(subscription);
    return subscription;
  }

  subscribeToAIHandoffs(callback: (payload: any) => void) {
    const subscription = supabase
      .channel('ai_handoffs')
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'ai_handoffs' }, 
        callback
      )
      .subscribe();
    
    this.subscriptions.push(subscription);
    return subscription;
  }

  unsubscribeAll() {
    this.subscriptions.forEach(subscription => {
      supabase.removeChannel(subscription);
    });
    this.subscriptions = [];
  }

  unsubscribe(subscription: any) {
    supabase.removeChannel(subscription);
    this.subscriptions = this.subscriptions.filter(sub => sub !== subscription);
  }
}

export const realtimeService = new SupabaseRealtimeService();
